import React from 'react'

const ExportRunningError = () =>
  <div>Project list cannot be opened while exports are processing.</div>

export const ExportRunningErrorConfig = { title: 'Cannot Open Projects List' }
export default ExportRunningError



// WEBPACK FOOTER //
// ./src/components/ExportRunningError/index.js